import { app } from '@/main';
import Vue from 'vue';
import Router from 'vue-router';

import { buildRouter, routes, groups } from './buildRouter';
import { Group } from './group.model';
import { Route } from './route.model';

Vue.use(Router);

const getRouter = () => {
  return buildRouter(Router);
};

const getParentRoute = () => {
  const mainRoutes = getMainRoutes();
  const currentRoute = getCurrentRoute();

  return mainRoutes.find((route: Route) => {
    return currentRoute.path.startsWith(route.path);
  });
};

const getMainRoutes = () => {
  return routes.filter((route: Route) => {
    return route.meta && route.meta.$group;
  });
};

const getGroupById = (id: string): Group | undefined => {
  return groups.find(group => group.id === id);
};

const getCurrentGroup = (): Group => {
  if (app.$route.meta && app.$route.meta.$group) {
    return app.$route.meta && app.$route.meta.$group;
  }

  const parentRoute = getParentRoute();
  return parentRoute.meta && parentRoute.meta.$group;
};

const getCurrentRoute = () => {
  return app.$route;
};

const getVisibleGroups = () => {
  return groups.filter(group => group.isVisible());
};

export {
  routes,
  groups,
  getGroupById,
  getVisibleGroups,
  getCurrentGroup,
  getCurrentRoute,
  getRouter,
  getParentRoute
};
export default getRouter;
